import axios from 'axios';
import { APIV2 } from '../../../backend';
import { useAppContext } from '../../../hooks/context/AppContext';

// Common error handler
const handleError = (error: unknown, context: string) => {
  console.error(`Error ${context}:`, error);
  return null;
};



// Custom hook for API client
export const useApiClient = () => {
  const { authData } = useAppContext();

  const apiClient = axios.create({
    baseURL: APIV2,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authData.idToken}`, // Using token from context
    },
  });

  // Profile API
  const getProfile = async () => {
    try {
      const response = await apiClient.get('/user/profile');
      return response.data;
    } catch (err) {
      return handleError(err, 'fetching profile');
    }
  };

  return {
    getProfile,
  };
};